<template>
  <div class="text-center">
    <div class="flex flex-row">
      <div class="flex-col m-auto"><strong>Authenticated:</strong> {{ isAuthenticated }}</div>
    </div>
    <div class="flex flex-row">
      <div class="flex-col m-auto"><strong>Email: </strong>{{ context.user.email }}</div>
    </div>
    <div class="flex flex-row">
      <div class="flex-col m-auto"><strong>Role: </strong> {{ context.user.role }}</div>
    </div>
    <!-- <div class="flex flex-row">
      <div class="flex-col m-auto">
        {{ context.user.permissions }}
      </div>
    </div> -->
    <div class="flex flex-row mt-3">
      <div class="grid grid-cols-4 gap-4 m-auto">
        <button
          class="px-4 py-2 font-semibold bg-red-200 hover:bg-red-400 cursor-pointer shadow-lg shadow-gray-500/50 rounded-lg"
          id="toggle-to-admin-role"
          type="button"
          @click="toggleRole(adminRole)"
        >
          Admin
        </button>
        <button
          class="px-4 py-2 font-semibold bg-lime-200 hover:bg-lime-400 cursor-pointer shadow-lg shadow-gray-500/50 rounded-lg"
          id="toggle-to-employee-role"
          type="button"
          @click="toggleRole(employeeRole)"
        >
          Employee
        </button>

        <button
          class="px-4 py-2 font-semibold bg-blue-200 hover:bg-blue-400 cursor-pointer shadow-lg shadow-gray-500/50 rounded-lg"
          id="toggle-to-manager-role"
          type="button"
          @click="toggleRole(managerRole)"
        >
          Manager
        </button>
        <button
          class="px-4 py-2 font-semibold bg-pink-200 hover:bg-pink-400 cursor-pointer shadow-lg shadow-gray-500/50 rounded-lg"
          id="toggle-to-editor-role"
          type="button"
          @click="toggleRole(editorRole)"
        >
          Editor
        </button>
        <button
          class="px-4 py-2 font-semibold bg-yellow-200 hover:bg-yellow-400 cursor-pointer shadow-lg shadow-gray-500/50 rounded-lg"
          id="toggle-to-editor-role"
          type="button"
          @click="toggleRole(deliveryLeaderRole)"
        >
          Delivery Leader
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useEnvironmentFlags } from "@/core/composables/useEnvironmentFlags";
import { useEmployeesApi } from "@/core/composables/useEmployeesApi";
import { usePermissions } from "@/core/composables/usePermissions";
import { RoleEnum } from "@/core/enum";
import { mockUser, useAppContextStore } from "@/core/store";
import { user } from "@/core/store/UserState";
import { computed } from "vue";

// component

const { isProdEnvironment } = useEnvironmentFlags();

// types
// props
// context

const contextStore = useAppContextStore();
const context = computed(() => contextStore.context);

const { isAuthenticated } = usePermissions(context.value.user);
// emit
// api

const { postRole } = useEmployeesApi();

// state

const adminRole = RoleEnum.ADMINISTRATOR;
const managerRole = RoleEnum.MANAGER;
const employeeRole = RoleEnum.EMPLOYEE;
const editorRole = RoleEnum.EDITOR;
const deliveryLeaderRole = RoleEnum.DELIVERYLEADER;

// computed
// methods

// event handlers

const toggleRole = async (role: RoleEnum) => {
  await postRole("1", role);
  isProdEnvironment.value ? user.load() : mockUser.load();
  location.reload();
};

// watchers
// lifecycle
</script>
